import { useWhiteLabelling } from 'components/WhiteLabellingProvider';
import { useFeatures } from 'hooks/useFeatures';
import useIsApprovedUser from './useIsApprovedUser';
import useUser from './useUser';

/*
 * Hook to determine if the quote queries (quotes screen, totals, checkout, doc) should be paused.
 * Mirrors the inputs market pause: whoever has no quotes of their own - a seller, or a user still
 * registering or waiting on review - never hits the quote resolvers. Fresh tenants are in that set
 * only until ConsolidatedInputs launches, which gives them quotes of their own.
 */
const useIsQuotesQueryPaused = () => {
  const { isInputsType } = useWhiteLabelling();
  const { isSeller, user } = useUser();
  const isApprovedUser = useIsApprovedUser();
  const { isEnabled } = useFeatures();
  const hasQuotes = isInputsType || isEnabled('ConsolidatedInputs');

  const isQuotesQueryPaused = !hasQuotes || !isApprovedUser || isSeller || !user?.profileId;
  return isQuotesQueryPaused;
};

export default useIsQuotesQueryPaused;
